import {
  changeDictionaries,
  orgKindList,
  orgTyleList,
  cooperationList,
  completeStatusList,
  sendSalaryList
} from '@/utils/dictionary.js'
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle'

// 运营端-学期服务管理-服务列表 表格表头
export const semesterOrgListColumns = [
  key('年度', 'yearName', tableColumnsWidth.type2),
  key('学期', 'termName', tableColumnsWidth.type2),
  slot('提供课后服务机构', 'orgNumber', tableColumnsWidth.type2, {
    align: 'center'
  }),
  slot('学期开展课后服务学校', 'schoolNumber', tableColumnsWidth.type2, {
    align: 'center'
  }),
  key('生成时间', 'createTime', tableColumnsWidth.type3),
  slot('操作', 'action', tableColumnsWidth.action, { fixed: 'right' })
]

// 运营端-学期服务管理添加-服务列表 表格表头
export const actOrgListColumns = [
  slot('序号', 'index', tableColumnsWidth.type),
  key('机构名称', 'orgName', tableColumnsWidth.type2),
  key('区域', 'areaName', tableColumnsWidth.type2)
]
// 运营端-学期服务管理添加-服务列表 表格表头
export const actSchoolListColumns = [
  slot('序号', 'index', tableColumnsWidth.type),
  key('学校名称', 'orgName', tableColumnsWidth.type2),
  key('区域', 'areaName', tableColumnsWidth.type2)
]

// 1.运营端-教育局-教育局列表 1.运营端-学校-学校列表 表格表头
export const opeEduListColumns = [
  key('单位名称', 'name', 280, {
    render: (h, params) => {
      return h(
        'div',
        {
          style: { padding: '8px 0' }
        },
        [
          h('div', [params.row.name]),
          h(
            'div',
            {
              style: {
                paddingTop: '8px',
                color: 'rgb(163, 176, 199)'
              }
            },
            [`(${params.row.shortName})`]
          )
        ]
      )
    },
    fixed: 'left'
  }),
  key('单位类型', 'orgType', tableColumnsWidth.type2, {
    render: (h, params) => {
      return h('div', [changeDictionaries(orgTyleList)[params.row.orgType]])
    },
    align: 'center'
  }),
  key('单位类别', 'orgKind', tableColumnsWidth.type2, {
    render: (h, params) => {
      return h('div', [changeDictionaries(orgKindList)[params.row.orgKind]])
    },
    align: 'center'
  }),
  // key('参与平台发放教师工资', 'sendSalary', tableColumnsWidth.type5, {
  //   render: (h, params) => {
  //     return h('div', [changeDictionaries(sendSalaryList)[params.row.sendSalary]]);
  //   }
  // }),
  // key('组织机构代码', 'organizeCode', tableColumnsWidth.type3),
  key('总部区域', 'areaName', tableColumnsWidth.type6),
  key('单位联系人', 'contactName', tableColumnsWidth.type3),
  key('详细地址', 'orgAddr', tableColumnsWidth.default),
  key('合作状态', 'coSts', tableColumnsWidth.type2, {
    render: (h, params) => {
      return h(
        'div',
        {
          style: {
            color: changeDictionaries(cooperationList, 'color')[
              params.row.coSts
            ]
          }
        },
        [changeDictionaries(cooperationList)[params.row.coSts]]
      )
    },
    align: 'center'
  }),
  key('信息完善状态', 'infoSts', tableColumnsWidth.type3, {
    render: (h, params) => {
      return h(
        'Tag',
        {
          props: {
            color: changeDictionaries(completeStatusList, 'tagColor')[
              params.row.infoSts
            ]
          }
        },
        [changeDictionaries(completeStatusList)[params.row.infoSts]]
      )
    },
    align: 'center'
  }),

  key('更新时间', 'operateTime', tableColumnsWidth.type4),
  slot('操作', 'action', tableColumnsWidth.action, { fixed: 'right' })
]

// 运营端-服务-服务列表-查询表单
export const opeOrgListSearchFormValidate = {
  keywords: '', // 单位全称、简称、组织机构代码、联系人姓名、手机号等
  orgType: '', // 单位类别
  area: '', // 总部区域
  coopStu: '', // 合作状态
  infoStu: '' // 信息完善状态
}

// 运营端-服务-服务列表 表格表头
export const opeOrgListColumns = [
  key('单位名称', 'orgName', tableColumnsWidth.type6),
  key('单位类型', 'orgKind', tableColumnsWidth.type2),
  key('单位类别', 'orgType', tableColumnsWidth.type2),
  key('组织机构代码', 'orgCode', tableColumnsWidth.type5),
  key('总部区域', 'area', tableColumnsWidth.type5),
  key('单位联系人', 'concat', tableColumnsWidth.type2),
  key('详细地址', 'address', tableColumnsWidth.type6),
  key('合作状态', 'coopStatus', tableColumnsWidth.type2),
  key('信息完善状态', 'infoStatus', tableColumnsWidth.type2),
  key('更新时间', 'updateTime', tableColumnsWidth.type3)
]

export const teacherTableColumns = [
  key(null, null, tableColumnsWidth.type1, {
    type: 'selection',
    fixed: 'left'
  }),
  key('姓名', 'userName', tableColumnsWidth.type2),
  key('手机号码', 'phoneNo', tableColumnsWidth.type3),
  key('所属部门', 'deptName', tableColumnsWidth.type5),
  key('工号', 'code', tableColumnsWidth.type4),
  key('职务职级', 'post', tableColumnsWidth.type6),
  key('账号状态', 'acctSts', tableColumnsWidth.type4, {
    render: (h, params) => {
      return h('div', [
        params.row.acctSts === 1
          ? '已启用'
          : params.row.acctSts === 0
          ? '已冻结'
          : ''
      ])
    }
  })
]
